<!--  -->
<template>
    <div class="sxyProductForm">
        <div class="search">
            <el-date-picker value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="params.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            <el-input v-model="params.customername" placeholder="请输入用户名"></el-input>
            <el-button class="search_btn" @click="handleSearch">搜索</el-button>
            <el-button class="export_btn" @click="exportCommonUserFormList">导出</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="用户名称" class-name="center" width="250px">
                <template slot-scope="scope">
                    <div class="headerurl_name">
                        <div class="headerurl">
                            <img v-if="scope.row.headerurl" :src="scope.row.headerurl" alt="">
                        </div>
                        <div class="name">{{scope.row.custmername}}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="填写时间" class-name="center" prop="datetime" width="160px"></el-table-column>
            <el-table-column show-overflow-tooltip :width="index < collist.length - 1 ? '200px' : ''" :label="item.colname" :class-name="index < collist.length - 1 ? 'center' : 'left'" v-for="(item, index) in collist" :key="index">
                <template slot-scope="scope">
                    <div v-if="scope.row.colvaluelist[index].colvalue">{{scope.row.colvaluelist[index].colvalue}}</div>
                    <div v-else>--</div>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="date" label="邮箱" class-name="center"></el-table-column>
            <el-table-column prop="date" label="手机号" class-name="center"></el-table-column>
            <el-table-column prop="date" label="城市" class-name="center"></el-table-column>
            <el-table-column prop="date" label="工作经验" class-name="center"></el-table-column> -->
        </el-table>
        <page ref="page" @getList="getCommonUserFormList" :total="total" />
    </div>
</template>

<script>
import page from '@/base/page/page3'
// import {getRelbmCommonFormList} from 'api/imageText'
import {mapActions} from 'vuex'
import {getCommonUserFormList, exportCommonUserFormList} from 'api/operateToolApi'
import {dateFormat} from 'common/js/tools'
export default {
    data() {
        return {
            tableData: [],
            page: {
                page: 1,
                pageSize: 10
            },
            total: 0,
            collist: [],
            params: {
                date: [],
                customername: '',
                innerid: ''
            }
        }
    },
    props: ['currenttop'],
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        this.params.innerid = JSON.parse(sessionStorage.moduleObj).productcommforminnerid
        this.getCommonUserFormList(this.page)
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        getCommonUserFormList(page) {
            this.setLoading(true)
            const params = JSON.parse(JSON.stringify(this.params))
            if (params.date.length) {
                params.begintime = params.date[0]
                params.endtime = params.date[1]
            }
            delete params.date
            getCommonUserFormList({
                data: Object.assign({}, page, {topiccode: this.currenttop.topiccode}, params),
                success: res => {
                    this.setLoading(false)
                    if (page.page === 1) {
                        this.collist = res.data.collist
                    }
                    this.page.page = page.page
                    this.tableData = res.data.content
                    this.total = res.data.pageinfo.rowCount
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        handleSearch() {
            this.page.page = 1
            this.$refs.page.pagination.page = 1
            this.getCommonUserFormList(this.page)
        },
        exportCommonUserFormList() {
            this.setLoading(true)
            const params = JSON.parse(JSON.stringify(this.params))
            if (params.date.length) {
                params.begintime = params.date[0]
                params.endtime = params.date[1]
            }
            delete params.date
            exportCommonUserFormList({
                data: params,
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '报名信息' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        page
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
    .sxyProductForm {
        padding-top: 5px;
        .search {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-bottom: 20px;
            .el-date-editor {
                margin-right: 30px;
                .el-input__icon {
                    line-height: 24px;
                }
                .el-range-separator {
                    line-height: 24px;
                }
            }
            .el-input {
                width: 220px;
                margin-right: 30px;
            }
            .search_btn {
                margin-right: 30px;
            }
            .export_btn {
                margin-left: 0;
            }
        }
        .el-table {
            .center {
                .cell {
                    text-align: center;
                }
            }
            .left {
                .cell {
                    text-align: left;
                }
            }
            .headerurl_name {
                display: flex;
                align-items: center;
                justify-content: center;
                .headerurl {
                    width: 60px;
                    height: 60px;
                    margin-right: 15px;
                    img {
                        width: 60px;
                        height: 60px;
                        border-radius: 50%;
                    }
                }
                .name {
                    max-width: 145px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 14px;
                    color: #606266;
                    text-align: left;
                    flex: 1;
                }
            }
        }
    }
</style>